import { useParams, useNavigate } from 'react-router-dom';

export default function RedirectSubpage() {
    // get the subpage parameter from the URL
    const { subpage } = useParams();

    // get the navigate function to redirect
    const navigate = useNavigate();

    // check if the subpage starts with "dr-"
    if (subpage.startsWith('dr-')) {
    // redirect to the old domain with the same subpage
        window.location.href ="https://old.iittp.ac.in/" + subpage;

    } else {
    // otherwise, navigate to the subpage component
    navigate(`/${subpage}`);
    }

    return null;
}